import { render, staticRenderFns } from "./ServiceComponent.vue?vue&type=template&id=162c19e0&scoped=true"
import script from "./ServiceComponent.vue?vue&type=script&lang=js"
export * from "./ServiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162c19e0",
  null
  
)

export default component.exports